import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// https://alligator.io/vuejs/lazy-loading-vue-cli-3-webpack/
function loadView (view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: loadView('HomeView')
    },
    {
      path: '/map/:type',
      name: 'map',
      component: loadView('MapView')
    },
    {
      path: '/admin',
      name: 'admin',
      component: loadView('AdminView')
    },
    {
      path: '/list',
      name: 'list',
      component: loadView('ListView')
    },
    {
      path: '/nearest',
      name: 'nearest',
      component: loadView('NearestView')
    },
    // {
    //   path: '/route',
    //   name: 'route',
    //   component: loadView('RouteView')
    // },
    {
      path: '/recent',
      name: 'recent',
      component: loadView('RecentView')
    },
    {
      path: '/info',
      name: 'info',
      component: loadView('InfoView')
    }
    // {
    //   path: '/route',
    //   name: 'route',
    //   component: RouteView
    // }
  ]
})
